import dayjs, { Dayjs } from 'dayjs'
import Styles from './ConfirmPauseModal.module.scss'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'

export const ConfirmPauseModal = ({
  variant,
  startDate,
  onConfirm,
}: {
  variant: 'generate' | 'publish' | 'all'
  startDate?: Dayjs
  onConfirm: () => void
}) => {
  const { closeModal } = useModals()

  let header = 'Pause Autopilot?'

  if (variant === 'generate') {
    header = 'Pause content generation?'
  } else if (variant === 'publish') {
    header = 'Pause publishing?'
  }

  return (
    <Modal.Root onPressOutside={closeModal}>
      <Modal.Header
        title={header}
        isConfirmation
        subHeader={
          <div className={Styles.confirmModalMessage}>
            {variant === 'all' && (
              <>
                <Text>Blaze will stop creating and publishing new content immediately.</Text>
                <Text>Your existing content won't be affected. Resume anytime in settings.</Text>
              </>
            )}
            {variant === 'generate' && (
              <>
                <Text>
                  {startDate && (
                    <>
                      After <strong>{dayjs(startDate).format('dddd, MMMM D, YYYY')}</strong>,{' '}
                    </>
                  )}
                  Blaze will stop creating new content.
                </Text>
                <Text>Your existing content won't be affected. Resume anytime in settings.</Text>
              </>
            )}
            {variant === 'publish' && (
              <>
                <Text>
                  Autopilot will stop automatically publishing content <strong>immediately</strong>.
                </Text>
                <Text>Note: Blaze will keep creating content, but you'll need to review and publish it manually.</Text>
                <Text>Posts you’ve already published stay live. Resume anytime in settings.</Text>
              </>
            )}
          </div>
        }
      />
      <Modal.Footer isConfirmation>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="secondary" onPress={closeModal}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={onConfirm}>Turn Off</Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
